import { Account } from 'model/IChat';

interface UseHostIsAvailableForContactProps {
  account?: Account;
}

const useHostIsAvailableForContact = ({
  account,
}: UseHostIsAvailableForContactProps): boolean => {
  return (
    account?.hostPublicStatus === 'online' || account?.hostPublicStatus == null
  );
};

export default useHostIsAvailableForContact;
